import Client from 'pages/views/devices/socketClient';
import { CFD_MESSAGES } from 'pages/views/devices/socketClient/types';
import { ACTIONS_DROPDOWN } from 'pages/views/devices/types';
import { setCfdModal } from 'pages/views/devices/utils/helper';
import { removeHubEnabled } from 'pages/views/devices/utils/storage';

export const handleDisconnect = (type: ACTIONS_DROPDOWN) => {
  if (type === ACTIONS_DROPDOWN.HUB) {
    Client.disconnect();
    removeHubEnabled();
  } else if (type === ACTIONS_DROPDOWN.CFD) {
    Client.send(CFD_MESSAGES.CLOSE);
  }
  setCfdModal(undefined);
};
